<template>
	<p-card>
		<card-header>
			<p class="tw-px-6 tw-py-6 uppercase job-name tw-text-center tw-m-0 text-primary">
				{{ selectedJobPosition.name }}
			</p>
		</card-header>
		<card-sub-header>
			<div class="tw-px-6 tw-py-6">
				<p class=" tw-m-0 text-info tw-text-center">Subordinados del puesto de {{ selectedJobPosition.name }}</p>
			</div>
		</card-sub-header>
		<div class="job-children-body tw-py-4">
			<div v-for="(child) in children" class="tw-flex tw-items-center tw-mb-2">
				<check-icon-filled class="tw-mr-2" /> <span class="text-info">{{ child.name }}</span>
				<span v-if="isFromOtherArea(child)" class="other-area-badge">[Otra área]</span>
			</div>
			<template v-if="mirroredChildren.length">
				<p class="tw-m-0 tw-mt-4 tw-mb-2 mirror-section-title">También aparece en esta área</p>
				<div v-for="(child) in mirroredChildren" class="tw-flex tw-items-center tw-mb-2">
					<v-icon size="16" class="tw-mr-2" color="#f09c2b">device_hub</v-icon>
					<span class="text-info">{{ child.name }}</span>
					<span v-if="isFromOtherArea(child)" class="other-area-badge">[Otra área]</span>
				</div>
			</template>
		</div>
		<card-footer class="tw-text-center tw-pt-5">
			<v-btn class="custom-button" color="primary" @click="$emit('closeClick')">Cerrar</v-btn>
		</card-footer>
	</p-card>
</template>

<script>
import PCard from '@/modules/shared/components/ui/Card/p-card';
import CardHeader from '@/modules/shared/components/ui/Card/CardHeader';
import CardFooter from '@/modules/shared/components/ui/Card/CardFooter';
import { concat, filter, map, pipe, pluck, propEq, reduce } from 'ramda';
import CheckIconFilled from '@/modules/shared/components/icons/check-icon-filled';
import CardSubHeader from '@/modules/shared/components/ui/Card/CardSubHeader';

export default {
	name: 'hierarchy-children-list-card',
	components: { CardSubHeader, CheckIconFilled, CardFooter, CardHeader, PCard },
	props: ['selectedJobPosition', 'hierarchyAssignation', 'filteredAreaId'],
	computed: {
		children() {
			const concatAll = reduce(concat, []);
			return pipe(
				pluck('jobPositions'),
				map(jobPositions => filter(propEq('fatherId', this.selectedJobPosition.id), jobPositions)),
				concatAll,
			)(this.hierarchyAssignation);
		},
		// Jobs mirrored under the selected boss (appear in the org chart under both their
		// real father and this boss). Real reporting line is unchanged.
		mirroredChildren() {
			const selectedId = this.selectedJobPosition.id;
			const concatAll = reduce(concat, []);
			return pipe(
				pluck('jobPositions'),
				map(jobPositions => filter(
					jp => (jp.mirrorFatherIds || []).indexOf(selectedId) !== -1,
					jobPositions,
				)),
				concatAll,
			)(this.hierarchyAssignation);
		},
	},
	methods: {
		isFromOtherArea(child) {
			return this.filteredAreaId && child.areaId !== this.filteredAreaId;
		},
	},
};
</script>

<style lang='scss' scoped>
.job-name {
	font-weight: bold;
}
.job-children-body {
	min-height: 200px;
}
.other-area-badge {
	color: #f09c2b;
	font-size: 11px;
	font-style: italic;
	margin-left: 6px;
}
.mirror-section-title {
	color: #f09c2b;
	font-size: 12px;
	font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/guideline-model/hierarchy/hierarchy-children/hierarchy-children-list-card.vue